<template>
  <Loading :loading="loading">
    <template>
      <div class="roles">
        <Roles
          v-for="(roleData, index) in rolesItems"
          :key="`a-${index}`"
          :loading="loading"
          :roleData="roleData"
          :selectable="selectable"
        />
      </div>
    </template>
  </Loading>
</template>

<script>
import Loading from "./loading.vue";
import Roles from "./Roles.vue";
import { toRefs } from "vue";

export default {
  components: { Loading, Roles },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rolesItems: {
      type: Array,
      default: () => [],
    },
    selectable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    // generate props data
    const { loading, rolesItems, selectable } = toRefs(props);

    return { loading, rolesItems, selectable };
  },
};
</script>
